module.exports = __webpack_public_path__ + "static/media/toggle-off.6eb308f9.svg";